export default "__VITE_ASSET__BWI_dWZY__"